var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 4.996094 1.570312 C 4.21875 1.570312 3.597656 2.210938 3.597656 2.992188 L 3.597656 31.324219 C 3.597656 32.105469 4.21875 32.75 4.996094 32.75 L 33.367188 32.75 C 34.140625 32.75 34.773438 32.105469 34.773438 31.324219 L 34.773438 2.992188 C 34.773438 2.210938 34.140625 1.570312 33.367188 1.570312 Z M 5.792969 3.089844 L 32.570312 3.089844 C 32.949219 3.089844 33.25 3.390625 33.25 3.765625 L 33.25 25.585938 L 26.964844 25.585938 C 25.199219 23.148438 23.101562 15.023438 26.347656 8.554688 C 19.492188 8.441406 11.585938 17.160156 11.582031 25.585938 L 5.113281 25.585938 L 5.113281 3.765625 C 5.113281 3.390625 5.414062 3.089844 5.792969 3.089844 Z M 5.792969 3.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.50b4a727c3f8c03d57af6d086d695e1c.svg";
export { ForwardRef as ReactComponent };